import { toUserCurrencyColumnName } from '@instinet-analytics/semantic-ui-components';
import {
    baseCurrencyComparator,
    currencyFormatUtils,
    numberFormatUtils,
} from '@instinet-analytics/core-lib';
import Column, { getBaseColumn } from './Column';
import ColumnType from './ColumnType';

const { c0FmtFx, c2FmtFx } = currencyFormatUtils;
const { N0, N4 } = numberFormatUtils;

const baseCurrencyColumn: Partial<Column<ColumnType.CURRENCY>> = {
    ...getBaseColumn(ColumnType.CURRENCY),
    sortCompareFunction: baseCurrencyComparator,
    scaleFunction: (x: number, exchangeRate: number) => x * exchangeRate,
    textAlign: 'right',
};

const baseCurrencyPriceColumn: Partial<Column<ColumnType.CURRENCYPRICE>> = {
    ...baseCurrencyColumn,
    colType: ColumnType.CURRENCYPRICE,
    colFmt: N4,
};

export const avgPxC = {
    ...baseCurrencyPriceColumn,
    name: toUserCurrencyColumnName('Avg Px'),
    dataField: 'avgPxC',
    labelFunction: c2FmtFx,
    width: 103,
    tag: 'Order Data/Avg Px',
    desc: 'Average price',
    defaultSortDesc: true,
};

export const arrivalPD = {
    ...baseCurrencyPriceColumn,
    name: toUserCurrencyColumnName('Arrival'),
    dataField: 'arrivalPD',
    labelFunction: c2FmtFx,
    width: 103,
    tag: 'Order Data/Arrival Price',
    desc: 'Arrival price',
    defaultSortDesc: true,
};

export const fillAmt = {
    ...baseCurrencyColumn,
    name: toUserCurrencyColumnName('Traded'),
    dataField: 'fillAmt',
    colFmt: N0,
    labelFunction: c0FmtFx,
    width: 90,
    tag: 'Order Data/Traded',
    desc: 'Traded value',
    defaultSortDesc: true,
};

export const pncD = {
    ...baseCurrencyPriceColumn,
    name: toUserCurrencyColumnName('PNC'),
    dataField: 'pncD',
    labelFunction: c2FmtFx,
    width: 85,
    tag: 'Market Data/PNC',
    desc: "Previous night's close",
};

export const qtyAmt = {
    ...baseCurrencyColumn,
    name: toUserCurrencyColumnName('Ordered'),
    dataField: 'qtyAmt',
    colFmt: N0,
    labelFunction: c0FmtFx,
    width: 90,
    tag: 'Order Data/Ordered',
    desc: 'Ordered value',
    defaultSortDesc: true,
};

export const remAmt = {
    ...baseCurrencyColumn,
    name: toUserCurrencyColumnName('Leaves'),
    dataField: 'remAmt',
    colFmt: N0,
    labelFunction: c0FmtFx,
    width: 90,
    tag: 'Order Data/Leaves',
    desc: 'Value of shares remaining',
    defaultSortDesc: true,
};
